import {HISTORY} from '../types';

export const historyAction = ( data ) => async (dispatch) =>{

  dispatch({
      type: HISTORY,
      payload: data
  });

}